export default __webpack_public_path__ + "static/media/img-0338-ukraine-full-face.6316b733.png";